<template>
    <div>
        <div class="navigation">
            <div class="logo">
                <img class="logoImg" src="../../assets/images/logo.png" alt="">
                <img class="logoName" src="../../assets/images/logoName.png" alt="">
            </div>
            <div class="navList">
                <div :class="currentId === item.id?'active navItem':'navItem'" v-for="item in navList" :key="item.id" @click="navMenuClick2(item)">
                    <i :class="item.icon"></i>
                    <span>{{item.name}}</span>
                </div>
            </div>
        </div>
        <div class="subMenu" v-if="currentNav && currentNav.children">
            <el-scrollbar style="height: 100%;">
                <div style="padding: 0 10px;">
                    <div class="typeName">
                        {{currentNav.name}}
                    </div>
                    <el-menu :mode="'vertical'" :default-active="menuActiveId">
                        <sub-menu
                            v-for="menu in currentNav.children"
                            :key="menu.id"
                            :menu="menu">
                        </sub-menu>
                    </el-menu>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
    import SubMenu from './common_left_submenu'
    export default {
        name: "common_left",
        data(){
            return{
                currentId: '0',
                currentNav: {},
                navList: this.navList,
                menuActiveId: '',
                currentData: {}, // 当前路由顶层的数据
            }
        },
        components:{
            SubMenu
        },
        watch:{
            '$route.path':{
                handler(){
                    // console.log('所有数据', this.navList);
                    this.findPath(this.navList)
                    this.currentNav = this.currentData
                    let hasSubMenu = this.currentNav.children?true:false
                    this.$emit('hasSubMenu',hasSubMenu)
                },
                immediate: true
            },
        },
        mounted () {
            this.menuActiveId = window.sessionStorage.getItem('menuActiveId')
            this.routeHandle(this.menuActiveId)
            window.addEventListener('setItem', ()=> {
                this.menuActiveId = window.sessionStorage.getItem('menuActiveId')
            })
        },
        methods: {
            // 递归寻找path
            findPath(data){
                data.forEach(item => {

                    if (item.children&&item.children.length!=0) {
                        // console.log('data1', this.$route.path);
                        this.findPath(item.children)
                    }else if(this.$route.path == item.path){
                        // 找到了， 打印一下console就知道对应路由的数据
                        // console.log('找到了', item);
                        // console.log('找到了', item.parentUuid);
                        // tabs左侧选中状态
                        this.currentId = item.id
                        // tabs右侧选中状态就是 id
                        this.resetSetItem('menuActiveId',item.id);
                        if (item.parentUuid != '') {
                            // console.log('进入找父级', );
                            this.findparentId(item.parentUuid, this.navList)

                        }else{
                            // console.log('没有子级', item);
                            this.currentId = item.id
                            this.currentData = this.navList[0]
                            // this.resetSetItem('menuActiveId',item.id);
                            window.sessionStorage.setItem('activeMenuSess',item.id)
                        }
                    }
                });
            },
            // 寻找最厅层的父级uuid
            findparentId(parentUuid, data){
                data.forEach(item=>{
                    if (item.id == parentUuid ) {
                        // console.log('父层uuid', item.id);
                        if (item.parentUuid!= '') {
                            // console.log('找到父级uuid， 但是还有父级', );
                            this.findparentId(item.parentUuid, this.navList)
                        }else{
                            // console.log('找到厅层了',item.id );
                            // console.log('找到厅层了',item );
                            this.currentId = item.id
                            this.currentData = item
                            // this.resetSetItem('menuActiveId',item.id);
                            window.sessionStorage.setItem('activeMenuSess',item.id)
                        }
                    } else  if (item.children&&item.children.length!=0 ){
                        // console.log('没找到uuid，继续找', );
                        this.findparentId(parentUuid,item.children)
                    }

                })
            },
            navMenuClick2(val){
                this.currentId = val.id
                this.currentNav = val
                let hasSubMenu = this.currentNav.children?true:false
                this.$emit('hasSubMenu',hasSubMenu)
                if(val.url){
                    this.$router.push(val.url)
                    this.resetSetItem('menuActiveId',val.id)
                }else if (val.children[0].url){
                    this.$router.push(val.children[0].url)
                    this.resetSetItem('menuActiveId',val.children[0].id)
                }else if (val.children[0].children[0].url){
                    this.$router.push(val.children[0].children[0].url)
                    this.resetSetItem('menuActiveId',val.children[0].children[0].id)
                }
            },
            navMenuClick(val){
                this.currentId = val.id
                this.currentNav = val
                let hasSubMenu = this.currentNav.children?true:false
                this.$emit('hasSubMenu',hasSubMenu)
                if(val.url){
                    this.$router.push(val.url)
                    this.resetSetItem('menuActiveId',val.id)
                }
            },
            // 路由刷新定向
            routeHandle (id) {
                this.navList.some(item => {
                    if(item.id === id){
                        this.navMenuClick(item)
                        return true
                    } else {
                        this.childrenRoute(item.children,id,item)
                    }
                })
            },
            // 子菜单刷新
            childrenRoute(children,id,item){
                if(children){
                    children.some(child =>{
                        if(child.id === id){
                            this.navMenuClick(item)
                            return true
                        } else {
                            this.childrenRoute(child.children,id,item)
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">
.navigation{
    width: 90px;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    .logo{
        width: 100%;
        margin-bottom: 15px;
        img{
            display: block;
            margin: 0 auto;
            &.logoImg{
                width: 40px;
                height: 35px;
            }
            &.logoName{
                width: 60px;
                height: 36px;
            }
        }
    }
    .navList{
        width: 100%;
        padding-left: 7px;
        .navItem{
            font-size: 14px;
            width: 100%;
            height: 45px;
            line-height: 45px;
            padding: 0 10px;
            color: #666;
            cursor: pointer;
            i{
                font-size: 14px;
                padding-right: 5px;
            }
            &.active{
                background: #fff;
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
                color: #108EE9;
            }
            &:hover{
                color: #108EE9;
            }
        }
    }
}
    .subMenu{
        position: fixed;
        left: 90px;
        top: 60px;
        z-index: 999;
        width: 100px;
        height: 100%;
        border-right: 1px solid #ddd;
        .typeName{
            padding: 10px 0;
            font-size: 16px;
        }
        /deep/ .el-menu {
            border-right: none;
        }

    }
</style>



// WEBPACK FOOTER //
// src/views/layout/common_left.vue